var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e8dfd53a48cc9a06bd1d2fc2ad185fb8337535a6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-web@token-traxx"]={id:"e8dfd53a48cc9a06bd1d2fc2ad185fb8337535a6"};
      